// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29bC2","questions":"styles_questions__1rJVb","footer":"styles_footer__1qk4i"};